module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h1 id="slideshow_title" class="screen_reader_only">' +
((__t = ( I18n.t('widget.screen_reader_only.slideshow.title') )) == null ? '' : __t) +
'</h1>\n<p id="slideshow_description" class="screen_reader_only">' +
((__t = ( widgetDesc )) == null ? '' : __t) +
'</p>\n\n<div id="slideshow_widget" class="wrap" style="opacity:0">\n	<div class="controls">\n		<button type="button" class="btn prev" aria-label="' +
((__t = ( I18n.t('common.controls.previous') )) == null ? '' : __t) +
'"></button>\n		<button type="button" class="btn next" aria-label="' +
((__t = ( I18n.t('common.controls.next') )) == null ? '' : __t) +
'"></button>\n	</div>\n	<div class="slideshow_frame"></div>\n</div>\n';

}
return __p
}